import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react'
import { TbChevronRight } from 'react-icons/tb'

interface CollapsedButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  onShow?: boolean
}

export const CollapsedButton = (params: CollapsedButtonProps) => {
  return (
    <button 
      {...params}
      color="primary"
      className="rounded-full"
      title="Collapse"
    >
      <TbChevronRight className={`transition ${params?.onShow && "rotate-90"} me-4`} />
    </button>
  )
}